import { useFiltersContext } from '@/context'
import { HomeQualityCheckQueries } from '@/graphql/queries/homeQualityChecks.queries'
import { HomeQualityCheckList } from '@/types/HomeQualityCheck'
import { formatDate } from '@/util'

import { useGraphql } from '../useGraphql'

export const useHomeQualityChecks = () => {
  const [{ reservationMoveInRange, marketSegmentFilter, homeQualityChecksFilters }] = useFiltersContext()
  const { moveInDate, moveInMax } = reservationMoveInRange
  const { homeQualityCheckStatus } = homeQualityChecksFilters

  const reservationMoveInDate =
    moveInDate && moveInMax
      ? {
          start: formatDate(moveInDate, 'yyyy-MM-dd'),
          end: formatDate(moveInMax, 'yyyy-MM-dd'),
        }
      : moveInDate
        ? {
            start: formatDate(moveInDate, 'yyyy-MM-dd'),
            end: formatDate(moveInMax, 'yyyy-MM-dd'),
          }
        : undefined

  return useGraphql<{ homeQualityChecks: HomeQualityCheckList[] }>(
    HomeQualityCheckQueries.QUERY_KEYS.getHomeQualityChecks,
    HomeQualityCheckQueries.getHomeQualityChecks(),
    {
      filter: {
        limit: 50,
        reservationMoveInDate,
        marketSegmentIds:
          marketSegmentFilter.marketSegmentIds && marketSegmentFilter.marketSegmentIds.length > 0
            ? marketSegmentFilter.marketSegmentIds
            : undefined,
        status: homeQualityCheckStatus,
      },
    },
  )
}
